import { FC, useMemo } from 'react';

import { useTheme, Typography } from '@mui/material';
import { blueGrey } from '@mui/material/colors';
import { get } from 'lodash';
import Highlighter from 'react-highlight-words';

import { abbreviateId } from '../../../utils/humanizer';
import { CommentHighlighterShape } from './interface';

const CommentHighlighter: FC<CommentHighlighterShape> = ({ line }) => {
  const theme = useTheme();
  const isDark = get(theme, 'palette.mode', '') === 'dark';

  const mentions = line.match(/(?:\/)([^#]+)(?=#|$)/) || [];

  let text = line.replace(/[[\]']+/g,''); // removes all '[' and ']'
  mentions.forEach(mention => {
    const finalMentioned = mention.startsWith('0x') && mention.length === 42
      ? `${abbreviateId(mention)}`
      : mention;
    text = text.replaceAll(mention, `@${finalMentioned}`);
  });

  const mentionsForHighlight = useMemo(() => (
    mentions.map(mention => mention.startsWith('0x') && mention.length === 42
      ? `@${abbreviateId(mention)}`
      : `@${mention}`)
  ), [mentions]);

  if (mentions && mentions.length > 0) {
    return (
      <Highlighter
        searchWords={mentionsForHighlight}
        autoEscape
        textToHighlight={text}
        highlightStyle={{
          backgroundColor: blueGrey[isDark ? 900 : 50],
          borderRadius: '14px',
          color: get(theme, 'palette.text.primary', '#000'),
          fontSize: '0.95rem',
          fontWeight: 500,
          lineHeight: 2,
          padding: '4px 8px',
          whiteSpace: 'pre-wrap',
          wordWrap: 'break-word',
        }}
      />
    );
  }
  return (
    <Typography variant="body1">
      {line}
    </Typography>
  );
};

export default CommentHighlighter;
